'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EditorToolbar = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactAddonsCssTransitionGroup = require('react-addons-css-transition-group');

var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);

var _reactImmutableProptypes = require('react-immutable-proptypes');

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

var _baseAlerts = require('@bibliocommons/base-alerts');

var _baseAccessibilityManageFocus = require('@bibliocommons/base-accessibility-manage-focus');

var _baseAccessibilityManageFocus2 = _interopRequireDefault(_baseAccessibilityManageFocus);

var _baseFullScreenOverlay = require('@bibliocommons/base-full-screen-overlay');

var _baseFullScreenOverlay2 = _interopRequireDefault(_baseFullScreenOverlay);

var _utilsList = require('@bibliocommons/utils-list');

var _constantsList = require('@bibliocommons/constants-list');

var _baseStickyToolbar = require('@bibliocommons/base-sticky-toolbar');

var _baseStickyToolbar2 = _interopRequireDefault(_baseStickyToolbar);

require('@bibliocommons/assets/stylesheets/animations.scss');

var _toolbarListInfo = require('../../toolbar-list-info');

var _toolbarListInfo2 = _interopRequireDefault(_toolbarListInfo);

var _backButton = require('../../back-button');

var _backButton2 = _interopRequireDefault(_backButton);

var _settingsButton = require('../../settings-button');

var _settingsButton2 = _interopRequireDefault(_settingsButton);

var _addItemsButton = require('../../add-items-button');

var _addItemsButton2 = _interopRequireDefault(_addItemsButton);

var _publishButton = require('../../publish-button');

var _publishButton2 = _interopRequireDefault(_publishButton);

var _settings = require('../../settings');

var _settings2 = _interopRequireDefault(_settings);

var _publishForm = require('../../publish-form');

var _publishForm2 = _interopRequireDefault(_publishForm);

require('../styles/EditorToolbar.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EditorToolbar = exports.EditorToolbar = function (_BcReactComponent) {
  _inherits(EditorToolbar, _BcReactComponent);

  function EditorToolbar(props) {
    _classCallCheck(this, EditorToolbar);

    var _this = _possibleConstructorReturn(this, (EditorToolbar.__proto__ || Object.getPrototypeOf(EditorToolbar)).call(this, props));

    _this.bindAll('handlePublish', 'handleToggleSettings', 'renderAddItemsButton', 'renderSettings', 'renderMessages', 'manageSettingsFocus', 'renderPublishButton', 'handlePublishButtonClick');

    _this.state = {
      showSettings: false
    };
    return _this;
  }

  _createClass(EditorToolbar, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevState.showSettings && !this.state.showSettings) {
        this.props.restoreFocus(this._settingsButton);
      }
    }
  }, {
    key: 'handlePublish',
    value: function handlePublish(data) {
      this.props.handlePublishOverlayClose();
      this.props.handleFormSubmit(data);
    }
  }, {
    key: 'handlePublishButtonClick',
    value: function handlePublishButtonClick() {
      if ((0, _utilsList.isStaffOnlyList)(this.props.list)) {
        var params = {
          agencyScope: 'current_agency',
          intendedLocale: 'everywhere',
          isPrivate: false,
          visibility: _constantsList.VISIBILITY.LINK
        };

        if (this.props.list.get('listType') === 'staff_picks') {
          params.agencyScope = this.props.list.get('agencyScope');
        }

        this.handlePublish(params);
      } else {
        this.props.handlePublishOverlayOpen();
      }
    }
  }, {
    key: 'handleToggleSettings',
    value: function handleToggleSettings() {
      var _this2 = this;

      this.setState({ showSettings: !this.state.showSettings }, function () {
        if (_this2._stickyToolbar) {
          _this2._stickyToolbar.updateToolbarHeight();
        }
        _this2.manageSettingsFocus();
      });
    }
  }, {
    key: 'manageSettingsFocus',
    value: function manageSettingsFocus() {
      if (this.state.showSettings) {
        this.props.captureFocus(this._settingsContainer);
      }
    }
  }, {
    key: 'renderSettings',
    value: function renderSettings() {
      var _this3 = this;

      if (this.state.showSettings) {
        var _props = this.props,
            items = _props.items,
            list = _props.list,
            listScopes = _props.listScopes,
            listLanguages = _props.listLanguages,
            listLocales = _props.listLocales,
            selectableListTypes = _props.selectableListTypes,
            handleListPropertyChange = _props.handleListPropertyChange;


        return _react2.default.createElement(
          'div',
          { className: 'boxed-row row', ref: function ref(el) {
              _this3._settingsContainer = el;
            } },
          _react2.default.createElement(_settings2.default, {
            list: list,
            items: items,
            handleListPropertyChange: handleListPropertyChange,
            handleAddItemsToTopChange: this.props.handleAddItemsToTopChange,
            handleToggleSettingsMenu: this.handleToggleSettings,
            listScopes: listScopes,
            listLanguages: listLanguages,
            listLocales: listLocales,
            selectableListTypes: selectableListTypes,
            listHasUnsavedChanges: this.props.listHasUnsavedChanges,
            addItemsToTop: this.props.addItemsToTop })
        );
      }

      return null;
    }
  }, {
    key: 'renderAddItemsButton',
    value: function renderAddItemsButton() {
      if (this.props.editingAnchorBib) {
        return null;
      }

      return _react2.default.createElement(_addItemsButton2.default, { handleClick: this.props.handleOpenAddToList });
    }
  }, {
    key: 'renderPublishButton',
    value: function renderPublishButton() {
      if (this.props.editingAnchorBib) {
        return null;
      }

      return _react2.default.createElement(_publishButton2.default, {
        list: this.props.list,
        items: this.props.items,
        listHasUnsavedChanges: this.props.listHasUnsavedChanges,
        savingDraft: this.props.savingDraft,
        publishing: this.props.publishing,
        editingAnchorBib: this.props.editingAnchorBib,
        handleClick: this.handlePublishButtonClick });
    }
  }, {
    key: 'renderSettingsButton',
    value: function renderSettingsButton() {
      var _this4 = this;

      if (this.state.showSettings) {
        return _react2.default.createElement('div', { className: 'settings-button-placeholder' });
      }

      return _react2.default.createElement(_settingsButton2.default, {
        ref: function ref(el) {
          return _this4._settingsButton = el;
        },
        handleClick: this.handleToggleSettings,
        menuOpen: this.state.showSettings });
    }
  }, {
    key: 'renderMessages',
    value: function renderMessages() {
      return this.props.messages.map(function (message, index) {
        var key = message.get('key');

        if (key) {
          key = key.replace('{user_list_max_size}', _constantsList.MAX_LIST_ITEMS);
        }

        if (message.get('type') === 'error') {
          return _react2.default.createElement(
            _baseAlerts.AlertFailure,
            { key: index + '-' + key },
            key
          );
        }

        return _react2.default.createElement(
          _baseAlerts.AlertSuccess,
          { key: index + '-' + key },
          key
        );
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var _props2 = this.props,
          handleBackButtonClick = _props2.handleBackButtonClick,
          list = _props2.list;


      return _react2.default.createElement(
        'div',
        { className: 'cp-editor-toolbar' },
        _react2.default.createElement(
          _baseStickyToolbar2.default,
          {
            getOffsetForStickyToolbar: this.props.getOffsetForStickyToolbar,
            ref: function ref(el) {
              return _this5._stickyToolbar = el;
            } },
          _react2.default.createElement(
            'div',
            { className: 'boxed-row' },
            _react2.default.createElement(
              'div',
              { className: 'back-button-wrapper' },
              _react2.default.createElement(_backButton2.default, { handleClick: handleBackButtonClick })
            ),
            _react2.default.createElement(
              'div',
              { className: 'contents' },
              _react2.default.createElement(
                'div',
                { className: 'summary' },
                _react2.default.createElement(_toolbarListInfo2.default, {
                  list: list,
                  handleSaveAsDraft: this.handleSaveAsDraft,
                  saving: this.props.publishing || this.props.savingDraft,
                  failedToSave: this.props.failedToSave,
                  autoFocus: true })
              ),
              _react2.default.createElement(
                'div',
                { className: 'actions' },
                this.renderAddItemsButton(),
                _react2.default.createElement(
                  'span',
                  null,
                  this.renderPublishButton(),
                  this.renderSettingsButton()
                )
              )
            )
          ),
          this.renderSettings(),
          _react2.default.createElement(
            _reactAddonsCssTransitionGroup2.default,
            { transitionName: 'fade', transitionEnterTimeout: 500, transitionLeaveTimeout: 500 },
            this.renderMessages()
          ),
          _react2.default.createElement(
            _baseFullScreenOverlay2.default,
            {
              handleClose: this.props.handlePublishOverlayClose,
              open: this.props.showPublishOverlay },
            _react2.default.createElement(_publishForm2.default, {
              list: list,
              listLocales: this.props.listLocales,
              handleClose: this.props.handlePublishOverlayClose,
              handlePublish: this.handlePublish })
          )
        )
      );
    }
  }]);

  return EditorToolbar;
}(_baseBcReactComponent2.default);

EditorToolbar.propTypes = {
  list: _bcPropTypes.listShape,
  items: _reactImmutableProptypes2.default.listOf(_bcPropTypes.listItemShape),
  handleListPropertyChange: _react.PropTypes.func.isRequired,
  handleFormSubmit: _react.PropTypes.func.isRequired,
  handleBackButtonClick: _react.PropTypes.func.isRequired,
  handleOpenAddToList: _react.PropTypes.func.isRequired,
  handleAddItemsToTopChange: _react.PropTypes.func.isRequired,
  handlePublishOverlayOpen: _react.PropTypes.func.isRequired,
  handlePublishOverlayClose: _react.PropTypes.func.isRequired,
  listScopes: _reactImmutableProptypes2.default.map.isRequired,
  listLocales: _reactImmutableProptypes2.default.map.isRequired,
  selectableListTypes: _reactImmutableProptypes2.default.listOf(_react.PropTypes.string).isRequired,
  listHasUnsavedChanges: _react.PropTypes.bool.isRequired,
  savingDraft: _react.PropTypes.bool.isRequired,
  publishing: _react.PropTypes.bool.isRequired,
  failedToSave: _react.PropTypes.bool.isRequired,
  editingAnchorBib: _react.PropTypes.bool.isRequired,
  listPreviewURL: _react.PropTypes.string,
  messages: _reactImmutableProptypes2.default.listOf(_reactImmutableProptypes2.default.map),
  addItemsToTop: _react.PropTypes.bool,
  showPublishOverlay: _react.PropTypes.bool,

  captureFocus: _react.PropTypes.func.isRequired,
  restoreFocus: _react.PropTypes.func.isRequired
};

exports.default = (0, _baseAccessibilityManageFocus2.default)(EditorToolbar);


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/editor-toolbar/components/EditorToolbar.component.js
// module id = 1295
// module chunks = 0